import VideoThumbnail from 'react-video-thumbnail';
import TimesIcon from '../../assets/img/custom/x.svg';
import './styles.css';

const AttachmentPreview = ({
  attachment,
  handleClear,
  extension,
  attachmentType,
}) => {
  return (
    <div className="attachment-preview__container">
      <div className="attachment-preview__thumbnail">
        {attachmentType === 'video' ? (
          <VideoThumbnail videoUrl={attachment.preview} />
        ) : (
          <img src={attachment.preview} alt="thumbnail" />
        )}
      </div>
      <div className="attachment-preview__info">
        <div className="attachment-preview__title">
          {attachment?.name?.length > 15
            ? attachment.name.slice(0, 15) + '...' + extension
            : attachment.name}
        </div>
        <div className="attachment-preview__size">{attachment.size} MB</div>
      </div>
      <button
        type="button"
        className="attachment-preview__clear-attachment"
        onClick={handleClear}
      >
        <img src={TimesIcon} alt="clear" />
      </button>
    </div>
  );
};

export default AttachmentPreview;
